export const title = "t1asgb6r";
export const contentWithVideo = "c9wqauw";
export const content = "cy3pi4b";
export const buttons = "byf602i";
export const button = "b1rnvg8";
export const logo = "l125q78v";
export const videoContainer = "v1mjj2cp";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");